import { render, staticRenderFns } from "./project-report-sanea.vue?vue&type=template&id=4f9a5962"
import script from "./project-report-sanea.vue?vue&type=script&lang=js"
export * from "./project-report-sanea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports